import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'inspectionTypePipe'
})
export class InspectionTypePipe implements PipeTransform {

  transform(value: string | undefined): string {
    const labels: Record<string, string> = {
      'REGULAR': 'Begehung',
      'SCHADSTELLENPLAN': 'Schadstellenplan'
    };
    return value ? (labels[value] || value) : '';
  }
}
